@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

.dropdown-styled {
  width: 100%;
}

.date-picker {
  display: flex;
  height: 32px;
  width: 100%;
  background-color: var(--white);
  input {
    height: 32px;
    border: 1px solid var(--grey-500);
    border-right: none;
  }
  button {
    position: relative;
    height: 32px;
    border: 1px solid var(--grey-500);
  }
  .date-picker-button {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: @space-0 @space-8;
  }
}
